import { Component } from '@angular/core';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { HeaderComponent } from '../../../Common/header/header.component';

@Component({
    selector: 'app-disclosure',
    templateUrl: './disclosure.component.html',
    styleUrls: ['./disclosure.component.scss'],
    standalone: true,
    imports: [HeaderComponent, FooterComponent]

})
export class DisclosureComponent {

}
